import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoProduto } from '../../servicos/srv.produto';

@Component({
  selector: 'tsv2-prd-listar',
  templateUrl: './listar.component.html',
  providers: [ ServicoMsg, ServicoProduto ]
})
export class ProdutoListarComponent implements OnInit {
  @Input() items: any[];
  @Input() pagina: number;

  @Output() trocar = new EventEmitter();

  constructor(
    // private spinner: NgxSpinnerService,
    private servicoMsg: ServicoMsg,
    private servicoProduto: ServicoProduto
  ) {
    this.items = [];
    this.pagina = 1;
  }

  ngOnInit() {
  }

  removerProduto(id){
    let titulo = 'Remover o produto?';
    let texto = 'Produto removido com sucesso!';
    this.servicoMsg.exibeAlerta(titulo, id, this.servicoProduto, texto).then(r1 => {
      if (r1.success){
        this.trocar.emit(this.pagina);
      }
    }, (err: any) => {
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
